import * as TYPES from './types';
export default {
    [TYPES.SET_BLOGLISTINFO](payload) {
        this.blogListInfo = payload;
    },
    [TYPES.SET_CATEGORIES](payload) {
        this.categoryTitle = payload.title;
        this.categories = payload.list;
        this.showCategoryCount = payload.showCategoryCount
    },
    [TYPES.SET_BLOGRECENTPOSTS](payload) {
        this.recentPostInfo = payload
    },
    [TYPES.SET_SHARES](payload) {
        this.shares = payload
    },
};
